import t from 'tcomb';

export default t.interface({
  join_code: t.Number
}, { strict: true, name: 'JoinCode' });


